// Ảnh đại diện: hiện ảnh nếu có, ngược lại hiện chữ cái đầu tên.
export default function Avatar({ src, name, size = 36 }) {
  const init = (name || '?').trim().split(/\s+/).slice(-1)[0]?.[0]?.toUpperCase() || '?';
  const base = { width: size, height: size, borderRadius: '50%', flexShrink: 0 };
  if (src) return <img src={src} alt={name || ''} style={{ ...base, objectFit: 'cover' }} />;
  return (
    <span
      style={{
        ...base,
        background: 'var(--accent)',
        color: '#fff',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 700,
        fontSize: size * 0.42,
      }}
    >
      {init}
    </span>
  );
}
